import { render, staticRenderFns } from "./SubscriptionTitle.vue?vue&type=template&id=17b6680c&scoped=true&"
import script from "./SubscriptionTitle.vue?vue&type=script&lang=js&"
export * from "./SubscriptionTitle.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionTitle.vue?vue&type=style&index=0&id=17b6680c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b6680c",
  null
  
)

export default component.exports